import { useQuery } from "@apollo/client";
import { TableStandard, TableToolBar, HeaderActionType, TableToolBarStacked } from "ui";
import { GET_PEOPLE_WITH_SESSION_COUNT } from "../../../../features/graphql/query/person/GetPeopleWithSessionCount";
import { useEffect, useState } from "react";
import { GridColDef, GridRowModel, GridRowId } from "@mui/x-data-grid";
import { format } from "date-fns";
import { Description, FolderShared, People } from "@mui/icons-material";
import { Box, Chip, Grid, IconButton, Typography } from "@mui/material";
import { orderBySessionsRun } from "../../../../tools/sessionTools";
import usePersonStore from "../../../store/personStore";
import { useNavigate } from "react-router";

const TABLE_COLUMNS: GridColDef[] = [
    {
        field: "firstName", headerName: "First Name", flex: 1, sortable: true, resizable: false
    }, {
        field: "lastName", headerName: "Last Name", flex: 1, sortable: true, resizable: false
    },
    {
        field: "locations", headerName: "Location(s)", flex: 2, sortable: true, resizable: false,
        renderCell: ({ value }) => {
            const hasLocations = value.length > 0
            if (hasLocations) {
                return (
                    <Grid container spacing={1} sx={{ paddingTop: 2, paddingBottom: 2, justifyContent: "start" }}>
                        {value.map((location: string) => (
                            <Grid key={`tags-chip-${location}`} style={{ marginTop: 1 }}>
                                <Chip className="chip" label={location} />
                            </Grid>
                        ))}
                    </Grid>
                )
            } else {
                return (<Typography>Please assign person to a location</Typography>)
            }
        }
    }, {
        field: "lastRunSession", headerName: "Date of Last Run Session", flex: .5, sortable: true, resizable: false,
        renderHeader: () => (
            <div style={{ whiteSpace: "break-spaces", textAlign: "start", fontWeight: 500, lineHeight: 1, justifyContent: "center", width: "100%" }}>Date of Last Run Session</div>
        ), renderCell: ({ value }) => {
            return value === "0001-01-01T00:00:00.000-05:00" ? "N/A" : format(new Date(value), "MM/dd/yyyy")
        }
    },
    {
        field: "totalCompleteSessions", headerName: "Total Complete Sessions", flex: .5, sortable: true, resizable: false,
        renderHeader: () => (
            <div style={{ whiteSpace: "break-spaces", textAlign: "start", fontWeight: 500, lineHeight: 1, justifyContent: "center", width: "100%" }}>Total Complete Sessions</div>
        )
    },
    {
        field: "sessionsReviewed", headerName: "Total Sessions Reviewed", flex: .5, sortable: true, resizable: false,
        renderHeader: () => (
            <div style={{ whiteSpace: "break-spaces", textAlign: "start", fontWeight: 500, lineHeight: 1, justifyContent: "center", width: "100%" }}>Total Sessions Reviewed</div>
        )
    },


]

function mapToTable(data: any) {
    const node = data.node
    const _data = {
        ...node,
        locations: node.locations?.edges?.map((x: any) => x.node.name),
        sessionsReviewed: node.workLists.filter((x: any) => x.status === "Read").length
    }
    return _data
}
const StaffProgressTable = ({ onBack }: { onBack?: () => void }) => {
    const { loading, data } = useQuery(GET_PEOPLE_WITH_SESSION_COUNT, {
        notifyOnNetworkStatusChange: true,
        variables: {
            query: "",
            first: 100,
            after: null
        }
    })
    const company = usePersonStore((state) => state.company);
    const [pageTableState, setPageTableState] = useState<{
        columns: GridColDef[],
        rows: GridRowModel[],
        selectionModel: (string | number)[];
        // selectionModel: GridRowSelectionModel;
        selections: {
            initial: GridRowId[],
            pageAssign: GridRowId[],
            prevAssign: GridRowId[],
            nextAssign: GridRowId[],
            unassign: GridRowId[],
            allSelected: GridRowId[]
        };
    }>({
        columns: [],
        rows: [],
        selectionModel: [],
        // selectionModel: { type: "include", ids: new Set() },
        selections: {
            initial: [],
            pageAssign: [], // Contains student IDs that have a relationship with person
            prevAssign: [], // Contains student IDs across page/table
            nextAssign: [], // Contains student IDs used to created a person/student relationship
            unassign: [],   // Contains student IDs used to remove the person/student relationship
            allSelected: [] // Contains student IDs for selections on table/page
        },
    })
    const navigate = useNavigate()

    useEffect(() => {
        setPageTableState((prevState) => {
            const columns = [...TABLE_COLUMNS]

            columns.push({
                field: "profile", headerAlign: "center",
                align: "center",
                headerName: 'Profile',
                sortable: false,
                resizable: false,
                editable: false,
                width: 100,
                renderCell: (params) => {

                    return (
                        <IconButton onClick={() => navigate(`/manage/users/details/${params.row.id}`)}>
                            <FolderShared />
                        </IconButton>
                    );
                },
            })
            // console.log(data?.personForSuperAdmin.map(mapToTable))
            const rows = orderBySessionsRun(data?.personStatsPerCompany?.edges.map(mapToTable));
            return {
                ...prevState,
                columns,
                rows
            }
        })
    }, [loading, data])

    return (
        <TableStandard
            renderToolbar={({ searchQuery, onSearch, onSearchClear }) => (
                <TableToolBar title="Staff Insights" subTitle={`@${company.name}`} onBack={onBack}
                    onSearch={onSearch}
                    onSearchClear={onSearchClear}
                    searchQuery={searchQuery}
                />
            )
            }
            columns={pageTableState.columns}
            rows={pageTableState.rows}
            loading={loading}
            disableBoxShadow
            pageSize={100}
            autoHeight

        />
    )
}

export default StaffProgressTable